import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";
import RouterAuth from "./routerAuth.jsx";
import NotFoundPage from "../pages/not-found-page/not-found-page";
import ErrorPage from "../pages/error-page/error-page";
import LoginPage from "../pages/login-page/login-page";
import { authenticate, updateRole, setUserLogin } from "@src/redux/auth";
import { IdleTimeoutManager } from "idle-timer-manager";
import { setError } from "../redux/error";

function RouterRoot() {
  const dispatch = useDispatch();
  let history = useHistory();
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  if (userInfo) {
    dispatch(authenticate(true));
    dispatch(setUserLogin(userInfo));
    dispatch(updateRole(JSON.stringify(userInfo.userPermission)));
  } else {
    localStorage.setItem("userInfo", "{}");
    localStorage.setItem("currentUrl", window.location.href);
    history.push("/login");
    window.location.reload();
  }

  useEffect(() => {
    const manager = new IdleTimeoutManager({
      timeout: userInfo ? userInfo.timeout || 1800 : 1800, //expired after timeout of user
      onExpired: (time) => {
        // localStorage.setItem("info-error-page", JSON.stringify({
        //   actionLabel: t("commons.go_to_login"),
        //   message: `<span>申し訳ございません。</span></br>
        //   <span>所定の時間を超過しましたので接続を切らせていただきました。</span></br>
        //   <span>画面を閉じて再度お手続き願います。</span></br>`,
        //   logOut: true
        // }))
        dispatch(
          setError({
            message: `<span>申し訳ございません。</span></br>
              <span>所定の時間を超過しましたので接続を切らせていただきました。</span></br>
              <span>画面を閉じて再度お手続き願います。</span></br>`,
          })
        );
        // sessionStorage.setItem("isErrorTimeout", true);
        history.push("/error");
      },
    });
    return () => {
      manager.clear();
    };
  }, []);

  return (
    <Switch>
      <Route exact path="/">
        <Redirect to="/login" />
      </Route>
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/404" component={NotFoundPage} />
      <Route exact path="/error" component={ErrorPage} />
      <RouterAuth />
    </Switch>
  );
}

export default RouterRoot;
